// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'music-solid';

export const Component = () => (
  <path d='M24.132.191C23.988.048 23.797 0 23.557 0c-.144 0-.287 0-.335.048L9.477 4.98c-.432.097-.623.383-.623.91v10.681c-.91-.575-1.868-.862-2.921-.862h-.239c-1.293 0-2.347.432-3.257 1.246-.91.861-1.39 1.915-1.437 3.16.048 1.246.575 2.3 1.484 3.114.91.862 1.964 1.293 3.209 1.293h.43a4.6 4.6 0 0 0 3.257-1.293c.91-.862 1.39-1.916 1.437-3.113v-8.62L22.598 7.28v5.412c-.91-.622-1.868-.91-2.97-.91h-.238c-1.245 0-2.3.431-3.209 1.245-.91.862-1.389 1.916-1.436 3.161.047 1.198.526 2.251 1.436 3.114.91.862 1.964 1.293 3.209 1.293h.478a4.6 4.6 0 0 0 3.257-1.293c.91-.862 1.39-1.916 1.437-3.114V.958c0-.335-.144-.622-.432-.766h.002ZM22.6 2.347v2.826L10.819 9.387V6.562L22.6 2.347Z' />
);

export const viewBox = '0 0 25 25';
